import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/task-efficiency-reports/{creatorId}';
type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = ThisApi['body'] & ThisApi['params'];
type Output = ThisApi['response'];

const generateTaskEfficiencyReport = async ({
  creatorId,
  efficiencyData,
  filterParameters,
}: Input): Promise<Output> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.post(path, {
    efficiencyData,
    filterParameters,
  });
  return response.data;
};

export default generateTaskEfficiencyReport;
